<template>
    <div id="app">
        <div class="container main-app-container">
            <div class="row">
                <router-view :key="$route.fullPath"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',
    async mounted () {
        document.body.classList.add(process.env.NODE_ENV)
    }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/App.vue